import React from 'react';
import SeriesGroup from './groups/SeriesGroup';
import RanksGroup from './groups/RanksGroup';
import PlaylistsGroup from './groups/PlaylistsGroup';
import ShortsGroup from './groups/ShortsGroup';
import ReportGroup from './groups/ReportGroup';
import {
  SERIES_GROUPS, platformEntries, reportPlatforms, withCombined,
} from './soundstatsHelpers';

// Dispatches a loaded non-core group to its renderer.

export default function GroupBody({ group, json, chipIdx, setChipIdx }) {
  const isReport = group === 'report';
  const platforms = isReport ? reportPlatforms(json) : platformEntries(json);
  const entries = withCombined(platforms);

  if (!platforms.length) {
    const label = isReport ? 'report' : SERIES_GROUPS[group] ? SERIES_GROUPS[group].title.toLowerCase() : 'chart';
    return (
      <>
        <div className="ss-content-title"><h2>{SERIES_GROUPS[group]?.title || group}</h2></div>
        <div className="ss-card"><div className="ss-empty">No {label} data available for this artist.</div></div>
      </>
    );
  }

  if (isReport) return <ReportGroup platforms={platforms} entries={entries} chipIdx={chipIdx} setChipIdx={setChipIdx} />;
  if (group === 'songRanks' || group === 'albumRanks') return <RanksGroup group={group} platforms={platforms} entries={entries} chipIdx={chipIdx} setChipIdx={setChipIdx} />;
  if (group === 'playlistCurrent') return <PlaylistsGroup platforms={platforms} entries={entries} chipIdx={chipIdx} setChipIdx={setChipIdx} />;
  if (group === 'shorts') return <ShortsGroup platforms={platforms} entries={entries} chipIdx={chipIdx} setChipIdx={setChipIdx} />;
  if (SERIES_GROUPS[group]) return <SeriesGroup group={group} platforms={platforms} entries={entries} chipIdx={chipIdx} setChipIdx={setChipIdx} />;

  return <div className="ss-card"><div className="ss-empty">No renderer available for this section.</div></div>;
}
